"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const findOptionMatchingValue_1 = require("./findOptionMatchingValue");
exports.contentFeedInitialValues = (contentFeed) => {
    return {
        cacheLength: contentFeed.cacheLength,
        contentMapping: contentFeed.contentMapping,
        contentPushIndividualContentItems: contentFeed.contentPushIndividualContentItems,
        contentPushIsEnabled: contentFeed.contentPushIsEnabled,
        contentPushIsEnabledInitially: contentFeed.contentPushIsEnabled,
        headers: contentFeed.headers
            ? JSON.stringify(contentFeed.headers, null, 2)
            : null,
        name: contentFeed.name,
        responseType: findOptionMatchingValue_1.findOptionMatchingValue(contentFeed.responseType, constants_1.RESPONSE_TYPES, constants_1.DEFAULT_RESPONSE_TYPE_OPTION),
        url: contentFeed.url,
        useHeadersFromContentFeed: contentFeed.useHeadersFromContentFeed || null,
    };
};
//# sourceMappingURL=contentFeedInitialValues.js.map